import { defineStore } from "pinia";

type StatusType = {
  [setting: string]: string;
};

const useSaveStatusStore = defineStore("saveStatus", {
  state: (): {
    saveStatuses: StatusType;
  } => ({
    saveStatuses: {},
  }),
  getters: {
    getSaveStatuses: (state) => state.saveStatuses,
  },
  actions: {
    setSaveStatus(setting: string, value: string) {
      this.saveStatuses[setting] = value;
    },
  },
});

export default useSaveStatusStore;
